import { useEffect, useState } from 'react';

import { loadVGSCollect } from '@vgs/collect-js';
import useEnv from '@zenbusiness/application-commons-env';

const useVGSCollectUnit = () => {
  const { VGS_COLLECT_VERSION, VGS_COLLECT_ENV, VGS_COLLECT_UNIT_VAULT_ID } = useEnv();
  const [vgsCollect, setVgsCollect] = useState(null);

  useEffect(() => {
    const vgsConfig = {
      vaultId: VGS_COLLECT_UNIT_VAULT_ID,
      environment: VGS_COLLECT_ENV,
      version: VGS_COLLECT_VERSION
    };

    const initializeVGSCollect = async () => {
      const vgsInstance = await loadVGSCollect(vgsConfig);
      setVgsCollect(vgsInstance);
    };

    if (VGS_COLLECT_VERSION && VGS_COLLECT_ENV && VGS_COLLECT_UNIT_VAULT_ID) {
      initializeVGSCollect();
    }
  }, [VGS_COLLECT_VERSION, VGS_COLLECT_ENV, VGS_COLLECT_UNIT_VAULT_ID]);

  return { vgsCollect };
};

export default useVGSCollectUnit;
